const API = {
  GET_FETCH_SESSION_SUMMARY: {
    path: '/session/summary',
    method: 'GET',
  },
  GET_SESSION_URL: {
    path: '/meeting/generate-signed-url',
    method: 'POST',
  },
  POST_UPDATE_SESSION: {
    path: '/session/update',
    method: 'POST',
  },
  DELETE_DELETE_SESSION: {
    path: '/session/delete',
    method: 'DELETE',
  },
  POST_CREATE_SUPPORT_FEEDBACK: {
    path: '/feedback/create',
    method: 'POST',
  },
};
export default API;
